import React, { useState, useEffect } from "react";
import axios from "axios";
import { FiArrowUp, FiArrowDown } from "react-icons/fi";
import "./Featured.css";
import { CurrencyState } from "../Context";
import { Link, useNavigate } from "react-router-dom";

const Featured = () => {
  const [data, setData] = useState(null);

  const { currency } = CurrencyState();
  const { symbol } = CurrencyState();
  const navigate = useNavigate();

  const url = `https://api.coingecko.com/api/v3/coins/markets?vs_currency=${currency}&order=market_cap_desc&per_page=25&page=1&sparkline=false`;

  useEffect(() => {
    axios
      .get(url)
      .then((response) => {
        setData(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [currency]);

  // console.log(data)

  if (!data) return null;

  return (
    <div className="featured">
      <div className="container">
        {/* Left */}
        <div className="left">
          <h2>Explore top Assets such as Bitcoin, Ethereum and XRP</h2>
          <p>Join now and start trading all available assets</p>
          <Link to="/Signup">
            <button className="btn">Join Today</button>
          </Link>
        </div>

        {/* Right */}

        <div className="right">
          {/* BITCOIN */}
          <div
            className="card"
            onClick={() => navigate(`/AssetPage/${data[0].id}`)}
          >
            <div className="top">
              <Link to={`/AssetPage/${data[0].id}`}>
                <img src={data[0].image} alt="" />
              </Link>
            </div>
            <div>
              <h5>{data[0].symbol}</h5>
              <p>
                {symbol}
                {data[0].current_price.toLocaleString()}
              </p>
            </div>

            {data[0].price_change_percentage_24h < 0 ? (
              <span className="red">
                {data[0].price_change_percentage_24h.toFixed(2)}%
              </span>
            ) : (
              <span className="green">
                {data[0].price_change_percentage_24h.toFixed(2)}%
              </span>
            )}
          </div>
          {/* ETHEREUM */}
          <div
            className="card"
            onClick={() => navigate(`/AssetPage/${data[1].id}`)}
          >
            <div className="top">
              <Link to={`/AssetPage/${data[1].id}`}>
                <img src={data[1].image} alt="" />
              </Link>
            </div>
            <div>
              <h5>{data[1].symbol}</h5>
              <p>
                {symbol}
                {data[1].current_price.toLocaleString()}
              </p>
            </div>

            {data[1].price_change_percentage_24h < 0 ? (
              <span className="red">
                {data[1].price_change_percentage_24h.toFixed(2)}%
              </span>
            ) : (
              <span className="green">
                {data[1].price_change_percentage_24h.toFixed(2)}%
              </span>
            )}
          </div>

          <div
            className="card"
            onClick={() => navigate(`/AssetPage/${data[2].id}`)}
          >
            <div className="top">
              <Link to={`/AssetPage/${data[2].id}`}>
                <img src={data[2].image} alt="" />
              </Link>
            </div>
            <div>
              <h5>{data[2].symbol}</h5>
              <p>
                {symbol}
                {data[2].current_price.toLocaleString()}
              </p>
            </div>

            {data[3].price_change_percentage_24h < 0 ? (
              <span className="red">
                {data[2].price_change_percentage_24h.toFixed(2)}%
              </span>
            ) : (
              <span className="green">
                {data[2].price_change_percentage_24h.toFixed(2)}%
              </span>
            )}
          </div>

          <div
            className="card"
            onClick={() => navigate(`/AssetPage/${data[3].id}`)}
          >
            <div className="top">
              <Link to={`/AssetPage/${data[3].id}`}>
                <img src={data[3].image} alt="" />
              </Link>
            </div>
            <div>
              <h5>{data[3].symbol}</h5>
              <p>
                {symbol}
                {data[3].current_price.toLocaleString()}
              </p>
            </div>

            {data[3].price_change_percentage_24h < 0 ? (
              <span className="red">
                {data[3].price_change_percentage_24h.toFixed(2)}%
              </span>
            ) : (
              <span className="green">
                {data[3].price_change_percentage_24h.toFixed(2)}%
              </span>
            )}
          </div>

          <div
            className="card"
            onClick={() => navigate(`/AssetPage/${data[4].id}`)}
          >
            <div className="top">
              <Link to={`/AssetPage/${data[4].id}`}>
                <img src={data[4].image} alt="" />
              </Link>
            </div>
            <div>
              <h5>{data[4].symbol}</h5>
              <p>
                {symbol}
                {data[4].current_price.toLocaleString()}
              </p>
            </div>

            {data[4].price_change_percentage_24h < 0 ? (
              <span className="red">
                {data[4].price_change_percentage_24h.toFixed(2)}%
              </span>
            ) : (
              <span className="green">
                {data[4].price_change_percentage_24h.toFixed(2)}%
              </span>
            )}
          </div>

          <div
            className="card"
            onClick={() => navigate(`/AssetPage/${data[5].id}`)}
          >
            <div className="top">
              <Link to={`/AssetPage/${data[5].id}`}>
                <img src={data[5].image} alt="" />
              </Link>
            </div>
            <div>
              <h5>{data[5].symbol}</h5>
              <p>
                {symbol}
                {data[5].current_price.toLocaleString()}
              </p>
            </div>

            {data[5].price_change_percentage_24h < 0 ? (
              <span className="red">
                {data[5].price_change_percentage_24h.toFixed(2)}%
              </span>
            ) : (
              <span className="green">
                {data[5].price_change_percentage_24h.toFixed(2)}%
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Featured;
